<template>
  <div class="flex items-start justify-between">
    <div class="flex flex-col">
      <div class="flex items-center gap-2">
        <status-indicator-component :status="data.status" :position="getStatusIndicatorPosition" />
        <span class="text-xs uppercase text-ontick-steel-400 dark:text-gray-400">
          {{ symbolLabel }}
        </span>
      </div>
      <div class="flex max-w-[210px] items-center gap-2 overflow-hidden" ref="strategyNameContainer">
        <img
          v-if="data.partner_badge"
          :src="data.partner_badge"
          :alt="data.partner_name"
          :content="data.partner_name"
          v-tippy="{ arrow: true, theme: 'green' }"
          class="h-4 w-4"
        />
        <span
          :content="data.strategy_name"
          v-tippy="{ arrow: true, theme: 'green' }"
          class="text-md whitespace-nowrap font-semibold text-ontick-carbon-500 transition-all duration-1000 dark:text-gray-300 sm:text-lg"
          ref="strategyName"
        >
          {{ data.strategy_name }}
        </span>
      </div>
      <span class="text-[10px] font-medium text-gray-500 dark:text-gray-400"> ID: {{ data.investment_id }} </span>
    </div>
    <div class="flex translate-x-3 transform items-center gap-1">
      <ontick-switch-component
        v-if="data.status !== 'HIDDEN'"
        :active="data.status === 'RUNNING'"
        @switch="startStopInvestmentModal(isRunning)"
      />
      <ontick-form-dropdown-component
        content="Outras opções"
        v-tippy="{ arrow: true, theme: 'green' }"
        :optionCard="true"
        :disabledOptionDefault="true"
        :optionInitial="optionDefault"
        :options="dropdownOptions"
      />
      <!-- @optionSelected="dropdownOptionSelected($event, data)" -->
    </div>
  </div>
</template>

<script>
import * as icons from "@/app/assets/icons/investments";
import OntickFormDropdownComponent from "../../../../../shared/components/basic/ontick-form-dropdown.component.vue";
import OntickSwitchComponent from "../../../../../shared/components/basic/ontick-switch.component.vue";
import statusIndicatorComponent from "../card-investment/status-indicator.component.vue";
import event_bus from "../../../../../shared/utils/event_bus";
import { mapActions, mapGetters } from "vuex";
export default {
  components: {
    OntickFormDropdownComponent,
    OntickSwitchComponent,
    statusIndicatorComponent,
  },

  props: {
    data: {
      type: Object,
    },
    selectedVolume: {
      type: [Number, String],
    },
  },

  data() {
    return {
      animationInterval: null,
      optionDefault: {
        icon: icons.details,
        label: null,
      },
    };
  },

  computed: {
    ...mapGetters({
      selectedAccount: "accountTypes/getSelectedAccount",
    }),
    isRunning() {
      return this.data.status === "RUNNING";
    },
    getStatusIndicatorPosition() {
      if (this.data.type !== "PORTFOLIO") {
        return this.data.position_status;
      } else {
        return this.getPortfolioPosition;
      }
    },
    getPortfolioPosition() {
      return !this.data.sub_strategies || this.data.sub_strategies.every((item) => item.position_status === "Zerado")
        ? "Zerado"
        : "Posicionado";
    },
    symbolLabel() {
      if (this.data.type === "PORTFOLIO") {
        return "Portfólio";
      } else if (this.data.strategy_symbol === "ANY") {
        return "Multiativos";
      }
      return this.data.strategy_symbol;
    },
    dropdownOptions() {
      let options = [
        // {
        //   icon: icons.editParams,
        //   label: "Parâmetros",
        //   action: () => {
        //     // editar parâmetro
        //     this.$router.push({
        //       name: "Editar investimentos",
        //       params: {
        //         investment_id: this.data.investment_id,
        //       },
        //     });
        //   },
        // },
        {
          icon: icons.performance,
          label: "Histórico",
          action: () => {
            this.$router.push({
              name: "Histórico",
              params: {
                id: Number(this.data.investment_id),
                label: this.data.strategy_name,
              },
            });
          },
        },
        {
          icon: icons.removeInvestment,
          label: this.data.status != "HIDDEN" ? "Arquivar" : "Desarquivar",
          action: async () => {
            try {
              if (this.data.status != "HIDDEN") {
                if (this.data.status == "STOPPED") {
                  const response = await this.$api.post(this.$endpoint.INVESTMENT_HIDE, {
                    investment_id: Number(this.data.investment_id),
                  });
                  this.$swal({
                    icon: "success",
                    iconHtml: this.$icons.swal_success,
                    title: response.data.msg,
                  });
                  this.getInvestments();
                } else if (this.data.status == "RUNNING") {
                  this.$swal({
                    title: "Você deve parar o investimento para ocultá-lo",
                    icon: "error",
                    timer: 8000,
                  });
                }
              } else {
                if (this.data.status == "HIDDEN") {
                  const response = await this.$api.post(this.$endpoint.INVESTMENT_SHOW, {
                    investment_id: Number(this.data.investment_id),
                  });
                  this.$swal({
                    icon: "success",
                    iconHtml: this.$icons.swal_success,
                    title: response.data.msg,
                  });
                  // this.$emit("reload", { investmentActiveOrHidden: "HIDDEN" });
                  this.getInvestments();
                }
              }
            } catch (err) {
              console.error(err);
            }
          },
        },
        {
          icon: icons.chart,
          label: "Gráfico",
          action: () => {
            const queryName = this.data.type === "PORTFOLIO" ? "portfolioId" : "strategyId";
            this.$router.push({
              name: this.data.type === "PORTFOLIO" ? "PortfolioChart" : "StrategyChart",
              query: {
                [queryName]: Number(this.data.investment_id),
              },
            });
          },
        },
      ];

      // Não disponível para PORTFOLIO
      if (this.data.type !== "PORTFOLIO") {
        options.unshift({
          icon: icons.editParams,
          label: "Parâmetros",
          action: () => {
            // editar parâmetro
            this.$router.push({
              name: "Editar investimentos",
              params: {
                investment_id: this.data.investment_id,
              },
            });
          },
        });
      }

      if (
        this.selectedAccount.account_type === "PRD" &&
        ["RUNNING"].includes(this.data.status) &&
        ["FUTURES"].includes(this.data.strategy_market.toUpperCase())
      ) {
        // Tag de visibilidade "NOVO" para novas features
        const tagNew = {
          startDate: new Date("2025-07-22T00:00:00"), // data do lançamento da feature
          visibilityDays: 60, // visível por 60 dias
        };

        return [
          ...options,
          {
            icon: icons.edit_volume,
            label: "Editar volume",
            action: () => this.$emit("edit-volume", this.data),
            isNew: this.isVisible(tagNew.startDate, tagNew.visibilityDays),
          },
        ];
      }

      return options;
    },
  },

  methods: {
    ...mapActions({ getInvestments: "investment/getInvestments" }),
    startStopInvestmentModal(value) {
      // console.log(value);
      if (value) {
        event_bus.$emit("STOP_INVESTMENT_MODAL", {
          investmentInfo: this.data,
          selectedVolume: this.selectedVolume,
        });
      } else {
        event_bus.$emit("START_INVESTMENT_MODAL", {
          investmentInfo: this.data,
          selectedVolume: this.selectedVolume,
        });
      }
    },

    isVisible(startDate, visibilityDays) {
      const now = new Date();
      const endDate = new Date(startDate);
      endDate.setDate(startDate.getDate() + visibilityDays);
      return now >= startDate && now <= endDate;
    },
  },

  mounted() {
    const text = this.$refs.strategyName;
    const container = this.$refs.strategyNameContainer;

    const textWidth = text.getBoundingClientRect().width;
    const containerWidth = container.getBoundingClientRect().width;
    if (textWidth > containerWidth) {
      this.animationInterval = setInterval(() => {
        text.style.transform = `translateX(-${textWidth - containerWidth}px)`;
        setTimeout(() => {
          text.style.transform = `translateX(0px)`;
        }, 3000);
      }, 6000);
    }
  },

  beforeDestroy() {
    clearInterval(this.animationInterval);
  },
};
</script>

<style lang="scss" scoped></style>
